


































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'HistoryIntroEv',
  // props: {
  // },
  components: {},
  setup: () => {
    const timelineItems = [
      {
        year: 1824,
        title: 'Landesweite Entwicklungen der Feuerwehren',
        description:
          'Die ersten Spuren eines organisierten Brandschutzes finden sich 1824, als man in Everswinkel eine Ordnung des Feuerlöschwesens nach dem Vorbild der Nachbargemeinde Warendorf ausarbeitete.'
      },
      {
        year: 1879,
        title: 'Pflichtfeuerwehr',
        description:
          'Diese Feuerwehr war noch keine »freiwillige« Feuerwehr. Vielmehr war jeder männliche Einwohner zur Mithilfe verpflichtet. Soweit die Theorie. In der Praxis brachen einmal die Kufen an den Schlitten mit den Wasserbottichen, dann fehlten während eines Nachtbrandes die Fackeln, dann wieder waren die Lederschläuche undicht, und von der 500 Mann starken Pflichtfeuerwehr im Jahre 1879 waren keineswegs immer alle im Brandfall zur Stelle.'
      },
      {
        year: 1881,
        title: 'Erste Versammlungen zur Gründung einer Feuerwehr',
        description:
          '»Für das große und gefährliche Dorf Everswinkel Einrichtung einer Feuerwehr sehr zu empfehlen; sonstige Ausrüstung genügt«, urteilte die Königlich- Preußische Regierung im März 1881. Gemeint war damit natürlich die Einrichtung einer »freiwilligen« Feuerwehr. Ausgesuchte Mitglieder, Freiwilligkeit, gründliche Schulung, geeignetes Gerät: Das waren die Stichworte am Abend der Gründung einer Freiwilligen Feuerwehr in Everswinkel. Und dies sind auch heute noch die Eckpunkte, die eine effiziente und erfolgreiche Wehr ausmachen. Im August 1881 kam es dann zu einer ersten Versammlung von interessierten Männern. 42 meldeten sich zur Aufnahme, wählten aus ihren Reihen einen Vorstand und bereiteten die endgültige Gründung der Freiwilligen Feuerwehr Everswinkel vor.'
      },
      {
        year: 'Juni 1882',
        title: 'Gründung der Freiwilligen Feuerwehr',
        description:
          'Im Juni 1882 war es dann soweit, die Gründung wurde vollzogen – und seither wird traditionell am Vitusmontag das Stiftungsfest gefeiert.'
      },
      {
        year: 'Juni 1928 - 1946',
        title: 'Gründung und Auflösung der Freiwilligen Feuerwehr Müssingen',
        description:
          'Am 24.Juni 1928 erfolgte im Beisein des Kreisbrandmeisters auf dem Hof des Herrn Beermann in Müssingen die ordnungsgemäße Bildung des Löschzuges Müssingen, angegliedert an die Freiwillige Feuerwehr Everswinkel. In den 1945 nach Ende des Krieges verfassten Zustandsberichten über die Feuerwehr wird der Löschzug Müssingen nicht mehr erwähnt. Josef Röttgermann scheint im Sommer 1946 den Versuch unternommen zu haben, die Wehr wiederaufzubauen, denn neben den Aufzählung der Mitglieder seines Zuges fordert er die Gemeinde auf, seiner Abteilung die alten Druckschläuche zu verkaufen und das Spritzenhaus an der Müssinger Schule zu erwerben. Einem Schreiben des Amtsdirektors vom 10.12.1946 ist zu entnehmen, dass der Löschzug Müssingen aufgelöst war.',
        image: require('@/assets/history_timeline_1.png')
      },
      {
        year: '1936',
        title: 'Bergstraße Buttermann',
        description:
          'Provisorisches Feuerwehr Gerätehaus bei Buttermann/Jücker. Der erste Einstellplatz für einen umgebauten PKW Bj. 1934 gebraucht gekauft 1936 und umgebaut zum Transport der Feuerwehrmannschaft- und Gerätschaften.',
        image: require('@/assets/history_timeline_2.png')
      },
      {
        year: '1937',
        description:
          'Das erste Feuerwehr Gerätehaus wurde neben der alten Gerätehaus-Scheune Buttermann/Jücker, an der Bergstraße gebaut. Zwei Einstellplätze, Schlauchturm und zwei Gefängniszellen (Brummstall). Das erste original Feuerwehrfahrzeug LF8 wurde 1942 angeschafft nachdem der alte umgebaute PKW nicht mehr repariert werden konnte. Zu dem LF8 gehörte des weiteren ein TSA – Anhänger (Tragkraftspritzen-Anhänger).',
        image: require('@/assets/history_timeline_3.png')
      },
      {
        year: '1963',
        description: 'Gerätehaus Erweiterung auf drei Einstellplätze.',
        image: require('@/assets/history_timeline_4.png')
      },
      {
        year: '1975',
        description:
          'Durch die Kommunale Gebietsreform (1975) kam der Ortsteil Alverskirchen zur Gemeinde Everswinkel und somit auch die Feuerwehr. Das erste Feuerwehr Gerätehaus, gebaut 1894, im Unterdorf (Heute Hauptstraße). Fahrzeuge zu dieser Zeit, ein MTF (Mannschaftstransportfahrzeug) und ein LF8 (Löschgruppenfahrzeug).',
        image: require('@/assets/history_timeline_5.png')
      },
      {
        year: '1978',
        description:
          'Am Feuerwehrhaus 1 Feuerwehr Gerätehaus Neubau auf dem Geländer der alten Molkerei Schmaler Kamp.',
        image: require('@/assets/history_timeline_6.png')
      },
      {
        year: '1978',
        description:
          'Schließung des alten Feuerwehrgerätehaus an der Bergstraße. Umzug zum neuen Gerätehaus (Schmaler Kamp).',
        image: require('@/assets/history_timeline_7.png')
      },
      {
        year: '1979',
        description:
          'Einweihung des neuen Gerätehauses Am Feuerwehrhaus 1 (Schmaler Kamp)',
        image: require('@/assets/history_timeline_8.png')
      },
      {
        year: '1983',
        description:
          'Feuerwehrgerätehaus Neubau Alverskirchen, Alter Hof. Planung 1982 Bau und Fertigstellung 1983',
        image: require('@/assets/history_timeline_9.png')
      },
      {
        year: '2002',
        description:
          'Feuerwehrgerätehaus Anbau (Erweiterung). Beginn Okt.2002. Erweiterung von fünf auf acht Stellplätze plus DRK Unterkunft.',
        image: require('@/assets/history_timeline_10.png')
      },
      {
        year: '2004',
        description: 'Einweihung Feuerwehrgerätehaus-Anbau, am 11.09.2004',
        image: require('@/assets/history_timeline_11.png')
      },
      {
        year: '2009',
        description:
          'Feuerwehrgerätehaus Anbau (Erweiterung) Alverskirchen. Beginn Okt.2009. Erweiterung von zwei auf vier Stellplätze.',
        image: require('@/assets/history_timeline_12.png')
      }
    ];

    return {
      timelineItems
    };
  }
});
